import { Box, Text, Card, Flex, Button, Badge, Grid } from '@radix-ui/themes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import CircleProgress from '../shared/CircleProgress';
import LoadingIndicator from '../shared/LoadingIndicator';

const TeacherCompletions = () => {
    const periods = useSelector((state) => state.teacherAccount.periods).filter(period => period.status == 'active');
    // const teachingPlans = useSelector((state) => state.teacherAccount.teachingPlans);
    const courses = useSelector((state) => state.teacherAccount.courses);

    console.log('periods:', periods);
    console.log('courses:', courses);
    

    const [loading, setLoading] = useState(false);

    const renderPeriodHeader = (period) => {
        // const isActive = period.end_date && new Date(period.end_date) >= new Date();

        if (period.status == 'active') {
            // const filteredPlans = teachingPlans.filter(plan => plan.period_id == period.id);
            const filteredCourses = courses.filter(course => course.active_teaching_plan?.period_id == period.id);
            const averageCompletion = filteredCourses.reduce((acc, course) => acc + course.active_teaching_plan.progress_percentage, 0) / filteredCourses.length;
            // console.log('averageCompletion', averageCompletion);
            return (
                <Flex direction="column" gap="2">
                    {filteredCourses.length > 0 ? (
                        <Flex justify="start" align="center" gap="2">
                            <CircleProgress progress={averageCompletion} size={100} strokeWidth={5} label={`${averageCompletion.toFixed(2)}%`} labelSize="4" />
                            <Flex direction="column" justify="center" align="start" gap="2" pl="4">
                                <Text size="2">{period.title}</Text>
                                <Badge color="green">Active</Badge>
                            </Flex>
                            
                        </Flex>
                    ) : (
                        <Flex direction="column" justify="center" align="center" gap="2">
                            <Text size="2" as="p">{period.title}</Text>
                            <Text size="1">No active teacing plans</Text>
                        </Flex>
                    )}
                </Flex>
            );
        } else {
            return (
                <Flex justify="between" align="center" gap="2">
                    <Text>{period.title}</Text>
                    <Badge color="gray">Inactive</Badge>
                </Flex>
            );
        }
    };

    const renderPeriodCompletions = (period) => {
        return (
            <Flex direction="column" gap="2" pt="2">
                {courses.filter(course => course.active_teaching_plan?.period_id == period.id).map((course) => (
                    <Flex key={course.id} justify="between" align="center" gap="2">
                        <Text size="1" weight="bold">{course.level.label} | {course.subject.name}</Text>
                        <CircleProgress progress={Math.floor(course.active_teaching_plan.progress_percentage)} size={40} label={`${Math.floor(course.active_teaching_plan.progress_percentage)}%`} labelSize="1" />
                    </Flex>
                ))}
            </Flex>
        );
    };

    if (loading) {
        return <LoadingIndicator />;
    }

    return (
        <Box>
            {periods.length === 0 ? (
                <Flex direction="column" align="center" gap="4">
                    <Text>No active periods</Text>
                    <Button>Start New Period</Button>
                </Flex>
            ) : (
                <Flex direction="column" gap="2">
                    {periods.map(period => (
                        <Box key={period.id} style={{ borderBottom: '1px solid var(--gray-8)' }}>
                            {renderPeriodHeader(period)}
                            {renderPeriodCompletions(period)}
                        </Box>
                    ))}
                </Flex>
            )}
        </Box>
    );
};

export default TeacherCompletions;
